export default {
  inject: ['load'],
  data() {
    return {
      allVertigoAggravatingFactorsForOther: [],
      vertigoAggravatingFactor: null,
    };
  },
  methods: {
    getListOfVertigoAggravatingFactorsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVertigoAggravatingFactors').then(() => {
        if (this.$store.state.vertigoAggravatingFactorModule.successFlag) {
          this.allVertigoAggravatingFactorsForOther =
            this.$store.state.vertigoAggravatingFactorModule.allVertigoAggravatingFactors;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoAggravatingFactorModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVertigoAggravatingFactorsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getVertigoAggravatingFactorFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVertigoAggravatingFactor', id).then(() => {
        if (this.$store.state.vertigoAggravatingFactorModule.successFlag) {
          this.vertigoAggravatingFactor =
            this.$store.state.vertigoAggravatingFactorModule.vertigoAggravatingFactor;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vertigoAggravatingFactorModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVertigoAggravatingFactorFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vertigoAggravatingFactorModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
